module.exports = __webpack_public_path__ + "static/img/023.d23a0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/023.png
// module id = ctJX
// module chunks = 0